/**
 * Roher Bootstrap-Error-Screen, sobald der Tenant-Config-Fetch fehlschlägt.
 *
 * In DEV-010 ist das bewusst minimal — die vollständige Differenzierung
 * (generic vs. pinning-failure, Microcopy, Tap-to-Call) übernimmt DEV-016
 * im echten Technical-Error-Screen. Hier zeigen wir lediglich, dass der
 * Bootstrap fehlgeschlagen ist, damit Pilotpraxen das visuelle Fehlverhalten
 * abnehmen können.
 */
interface BootstrapErrorProps {
  readonly message: string;
}

export function BootstrapError(props: BootstrapErrorProps): JSX.Element {
  return (
    <div
      role="alert"
      className="flex h-screen w-full items-center justify-center bg-background p-6 text-center text-foreground"
    >
      <div className="max-w-app">
        <h1 className="text-2xl font-semibold tracking-tight">Terminabsage</h1>
        <p className="mt-6 text-sm text-error">{props.message}</p>
      </div>
    </div>
  );
}
